import AppDispatcher from '../dispatcher/AppDispatcher';
import HelpConstants from '../constants/HelpConstants';

const HelpActionCreator = {
  getTcData() {
    AppDispatcher.handleViewAction({
      actionType: HelpConstants.GET_TC_DATA,
    });
  },

  // After success comes to here, makes another service call with data retrived from the previous one..
  handleTcDataSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: HelpConstants.GET_TC_DATA_SUCCESS,
      data: response,
    });
  },

  handleTcDataError(response) {
    AppDispatcher.handleServerAction({
      actionType: HelpConstants.GET_TC_DATA_ERROR,
      data: response,
    });
  },

  // After getting data from 2nd service call, need to verify from here
  handleTcTextDataSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: HelpConstants.GET_TC_TEXT_DATA_SUCCESS,
      data: response,
    });
  },
  acceptTermsConditions() {
    AppDispatcher.handleViewAction({
      actionType: HelpConstants.REQUEST_ACCEPT_TC,
    });
  },
  backSetUrl(taskUrl, urlLink) {
    AppDispatcher.handleViewAction({
      actionType: HelpConstants.SET_BACK_URL,
      data: taskUrl,
      urlLink,
    });
  },
};

export default HelpActionCreator;
